import { Action } from 'redux';

export const SUPER_GET_CITATIONS_BY_CLIENT =
  'super-admin-rydin-sales-and-citations-reports/SUPER_GET_CITATIONS_BY_CLIENT';
export const getSuperCitationsByClient = (data: SelectReportData) => {
  return {
    type: SUPER_GET_CITATIONS_BY_CLIENT,
    payload: data,
  };
};
export const SUPER_SET_CITATIONS_BY_CLIENT =
  'super-admin-rydin-sales-and-citations-reports/SUPER_SET_CITATIONS_BY_CLIENT';
export const setSuperCitationsByClient = (data: ReadonlyArray<SuperCitationsByClientTable>) => ({
  type: SUPER_SET_CITATIONS_BY_CLIENT,
  payload: data,
});

export const SUPER_GET_CITATIONS_ISSUED = 'super-admin-rydin-sales-and-citations-reports/SUPER_GET_CITATIONS_ISSUED';
export const getSuperCitationsIssued = (data?: ReadonlyArray<SuperCitationsIssuedTable>) => ({
  type: SUPER_GET_CITATIONS_ISSUED,
  payload: data,
});

export const SUPER_SET_CITATIONS_ISSUED = 'super-admin-rydin-sales-and-citations-reports/SUPER_SET_CITATIONS_ISSUED';
export const setSuperCitationsIssued = (data: ReadonlyArray<SuperCitationsIssuedTable>) => ({
  type: SUPER_SET_CITATIONS_ISSUED,
  payload: data,
});

export const SUPER_GET_FULFILLMENT_BY_CLIENT =
  'super-admin-rydin-sales-and-citations-reports/SUPER_GET_FULFILLMENT_BY_CLIENT';
export const getSuperFulfillmentByClient = (data: SelectReportData) => ({
  type: SUPER_GET_FULFILLMENT_BY_CLIENT,
  payload: data,
});

export const SUPER_SET_FULFILLMENT_BY_CLIENT =
  'super-admin-rydin-sales-and-citations-reports/SUPER_SET_FULFILLMENT_BY_CLIENT';
export const setSuperFulfillmentByClient = (data: ReadonlyArray<SuperFulfillmentByClientTable>) => ({
  type: SUPER_SET_FULFILLMENT_BY_CLIENT,
  payload: data,
});

export const SUPER_GET_REVENUE_REPORTS = 'super-admin-rydin-sales-and-citations-reports/SUPER_GET_REVENUE_REPORTS';
export const getSuperRevenueReports = (data: SelectReportData) => ({
  type: SUPER_GET_REVENUE_REPORTS,
  payload: data,
});

export const SUPER_SET_REVENUE_REPORTS = 'super-admin-rydin-sales-and-citations-reports/SUPER_SET_REVENUE_REPORTS';
export const setSuperRevenueReports = (data: ReadonlyArray<SuperRevenueReportsTable>) => ({
  type: SUPER_SET_REVENUE_REPORTS,
  payload: data,
});

export const SUPER_GET_FULFILLMENT_REPORTS =
  'super-admin-rydin-sales-and-citations-reports/SUPER_GET_FULFILLMENT_REPORTS';
export const getSuperFulfillmentReports = (data?: ReadonlyArray<SuperFulfillmentReportsTable>) => ({
  type: SUPER_GET_FULFILLMENT_REPORTS,
  payload: data,
});

export const SUPER_SET_FULFILLMENT_REPORTS =
  'super-admin-rydin-sales-and-citations-reports/SUPER_SET_FULFILLMENT_REPORTS';
export const setSuperFulfillmentReports = (data: ReadonlyArray<SuperFulfillmentReportsTable>) => ({
  type: SUPER_SET_FULFILLMENT_REPORTS,
  payload: data,
});
export const SUPER_GET_REVENUE_BY_CLIENT = 'super-admin-rydin-sales-and-citations-reports/SUPER_GET_REVENUE_BY_CLIENT';
export const getSuperRevenueByClient = (data: SelectReportData) => ({
  type: SUPER_GET_REVENUE_BY_CLIENT,
  payload: data,
});

export const SUPER_SET_REVENUE_BY_CLIENT = 'super-admin-rydin-sales-and-citations-reports/SUPER_SET_REVENUE_BY_CLIENT';
export const setSuperRevenueByClient = (data: ReadonlyArray<SuperAdminRevenueByClient>) => ({
  type: SUPER_SET_REVENUE_BY_CLIENT,
  payload: data,
});
// citation by issues//
export const SUPER_SET_CITATIONS_BY_ISSUED =
  'super-admin-rydin-sales-and-citations-reports/SUPER_SET_CITATIONS_BY_ISSUED';
export const setSuperCitationByIssued = (data: ReadonlyArray<SuperCitationByIssuedTable>) => ({
  type: SUPER_SET_CITATIONS_BY_ISSUED,
  payload: data,
});

export const SUPER_GET_CITATIONS_BY_ISSUED =
  'super-admin-rydin-sales-and-citations-reports/SUPER_GET_CITATIONS_BY_ISSUED';
export const getSuperCitationsByIssued = (data: SelectReportData) => ({
  type: SUPER_GET_CITATIONS_BY_ISSUED,
  payload: data,
});
// citation by issued  //
export const NAVIGATE_ON_CITATION_ISSUE = 'super-admin-rydin-sales-and-citations-reports/NAVIGATE_ON_CITATION_ISSUE';
export const navigateOnCitationIssue = (data: string) => ({
  type: NAVIGATE_ON_CITATION_ISSUE,
  payload: data,
});
// superadmin fulfillment start  //

export const SUPER_SET_SALES_CITATIONS_FULFILLMENTS =
  'super-admin-rydin-sales-and-citations-reports/SUPER_SET_SALES_CITATIONS_FULFILLMENTS';
export const setSuperSalesCitationsFulfillments = (data: ReadonlyArray<SuperSalesCitationsFulfillmentsTable>) => ({
  type: SUPER_SET_SALES_CITATIONS_FULFILLMENTS,
  payload: data,
});

export const SUPER_GET_SALES_CITATIONS_FULFILLMENTS =
  'super-admin-rydin-sales-and-citations-reports/SUPER_GET_SALES_CITATIONS_FULFILLMENTS';
export const getSuperSalesCitationsFulfillments = (data: SelectReportData) => ({
  type: SUPER_GET_SALES_CITATIONS_FULFILLMENTS,
  payload: data,
});

// citation by issued Action //

export interface SuperSetCitationsByIssuedAction extends Action<typeof SUPER_SET_CITATIONS_BY_ISSUED> {
  payload: ReadonlyArray<SuperCitationByIssuedTable>;
}
// citation by issued Action end  //

// fulfillment //
export interface SuperSetSalesCitationsFulfillmentsAction extends Action<
  typeof SUPER_SET_SALES_CITATIONS_FULFILLMENTS
> {
  payload: ReadonlyArray<SuperSalesCitationsFulfillmentsTable>;
}

export interface SuperSetRevenueByClientAction extends Action<typeof SUPER_SET_REVENUE_BY_CLIENT> {
  payload: ReadonlyArray<SuperAdminRevenueByClient>;
}

export interface SuperSetCitationsByClientAction extends Action<typeof SUPER_SET_CITATIONS_BY_CLIENT> {
  payload: ReadonlyArray<SuperCitationsByClientTable>;
}

export interface SuperSetCitationsIssuedAction extends Action<typeof SUPER_SET_CITATIONS_ISSUED> {
  payload: ReadonlyArray<SuperCitationsIssuedTable>;
}

export interface SuperSetFulfillmentByClientAction extends Action<typeof SUPER_SET_FULFILLMENT_BY_CLIENT> {
  payload: ReadonlyArray<SuperFulfillmentByClientTable>;
}

export interface SuperSetRevenueReportsAction extends Action<typeof SUPER_SET_REVENUE_REPORTS> {
  payload: ReadonlyArray<SuperRevenueReportsTable>;
}

export interface SuperSetFulfillmentReportsAction extends Action<typeof SUPER_SET_FULFILLMENT_REPORTS> {
  payload: ReadonlyArray<SuperFulfillmentReportsTable>;
}

export type SuperAdminRydinSalesAndCitationReportsAction =
  | SuperSetCitationsByClientAction
  | SuperSetCitationsIssuedAction
  | SuperSetFulfillmentByClientAction
  | SuperSetRevenueReportsAction
  | SuperSetFulfillmentReportsAction
  | SuperSetRevenueByClientAction
  | SuperSetCitationsByIssuedAction
  | SuperSetSalesCitationsFulfillmentsAction;
